import React, { Component } from 'react';
import './Separator.css';

class Separator extends Component {
  render() {
    return (
      <div className="lp-separator-container">
        <div/>
      </div>
    );
  }
}

export default Separator;



// WEBPACK FOOTER //
// ./src/components/Separator.js